export const KEYS = {
    ARROW_UP: 'ArrowUp'.toLowerCase(),
    ARROW_DOWN: 'ArrowDown'.toLowerCase(),
    ENTER: 'enter'
};
